import { ChevronDownIcon, ChevronRightIcon } from '@chakra-ui/icons'
import {
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  CSSObject,
} from '@chakra-ui/react'
import { FC } from 'react'
import { IMeshData, IModelDesignData } from '../../../../../type/designType'
import { IMesh } from '../../../../../type/modelType'
import { toggleMeshOutline } from '../../../../../utils/design/customization'
import { ColorPanel } from './ColorPanel'
import { SwitchingVariantPanel } from './SwitchingVariantPanel'
import { TexturePanel } from './TexturePanel'

interface IProps {
  mesh: IMesh
  designData: IModelDesignData
  setMeshData: (meshData: IMeshData) => void
}

const accordionSx: CSSObject = {
  paddingBlock: '15',
  paddingInline: '30',
  flex: '1',
  textAlign: 'left',
  fontSize: 'md',
  position: 'relative',
}

export const AccordionByMesh: FC<IProps> = ({
  mesh,
  designData,
  setMeshData,
}) => {
  return (
    <AccordionItem>
      {({ isExpanded }) => (
        <>
          <AccordionButton
            sx={accordionSx}
            bg={isExpanded ? '#f2f4f6' : '#ffffff'}
            onMouseOver={() => toggleMeshOutline(mesh.variants, true)}
            onMouseLeave={() => toggleMeshOutline(mesh.variants, false)}
          >
            <Box flex="1" textAlign="left">
              {mesh.title}
            </Box>
            {isExpanded ? (
              <ChevronDownIcon fontSize="lg" />
            ) : (
              <ChevronRightIcon fontSize="lg" />
            )}
          </AccordionButton>

          <AccordionPanel pb={4}>
            <Box className="design-accordian-items">
              {mesh.colors && (
                <ColorPanel
                  mesh={mesh}
                  designData={designData}
                  setMeshData={setMeshData}
                />
              )}
              {mesh.textures && (
                <TexturePanel
                  mesh={mesh}
                  designData={designData}
                  setMeshData={setMeshData}
                />
              )}
              {(mesh.variants.length > 1 || mesh.canHideMesh) && (
                <SwitchingVariantPanel
                  mesh={mesh}
                  designData={designData}
                  setMeshData={setMeshData}
                />
              )}
            </Box>
          </AccordionPanel>
        </>
      )}
    </AccordionItem>
  )
}
